<template>

    <div class="flex-grow-1-scroll h-100 no-gutters provider-content" ref="container">
		<div class='d-flex flex-column h-100'>
			<loading ref="loading"></loading>

			<header class="p-2 header__dashboard--top d-flex align-items-center" style="z-index: 100;">
				<h1 class="h2" style="">{{ $t('translations.diagnostics')}}</h1>
			</header>
            <div class='flex-grow-1-scroll h-100'>
                <div v-if='networkFail' class='m-3 alert alert-danger text-dark'>
                    <h2>Warning</h2>
                    In order to keep using the {{ tBrand('app_name') }} system without any loss of service, you need to contact your IT provider
                    with the information below.
                </div>
                <div v-if='networkFail' class='m-3 alert alert-info text-dark'>
                    <h2>Information for your IT Provider</h2>
                    Please ensure that the following ports:
                    <ul class='mt-2 mb-2 text-dark' style='color: #212529;'>
                        <li class='text-dark'>80</li>
                        <li class='text-dark'>443</li>
                    </ul> 
                    are open for outgoing TCP connections to the following HSCN IP addresses: 
                    <ul class='mt-2 mb-2 text-dark'>
                        <li class='text-dark'>10.104.30.11</li> 
                        <li class='text-dark'>10.104.30.12</li>
                    </ul> 
                </div>
                <table class='table' style='border-collapse: separate !important; border-spacing: 2px;'>
                    <tr>
                        <th style='width: 25%'>Test Name</th>
                        <th style='width: 35%'>Result</th>
                        <th style='width: 40%'>Actions</th>
                    </tr>
                    <tr v-for='(test, key) in tests' :key='key'>
                        <td>{{test.title}}</td>
                        <td :class='"alert-" + test.class' v-html='test.message'></td>
                        <td  v-if='test.help[test.class]' v-html='test.help[test.class]'></td>
                    </tr>
                </table>
            </div>
            <footer class="container-footer">
                <div class="d-flex flex-row-reverse">
                    <button v-on:click.prevent="copyText()" class="btn btn-primary btn-round btn-sm mr-2">{{ $t('translations.copy')}}</button>
                </div>
            </footer>
        </div>
    </div>

</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
            tests: {
                browser: {
                    title: "Browser version",
                    message: "... checking ...",
                    class: "info",
                    help: {
                        success: "No action required.",
                        warning: "You are using an unsupported browser. Although the application will run, you may experience issues, such as slow updates. Consider using a modern browser such as Firefox, Chrome, Safari (10+), or MS Edge.",
                    },
                    test: this.isUnsupported,
                },
                websocket_current: {
                    title: "Outgoing websocket connections to current system",
                    message: "... checking ...",
                    class: "info",
                    help: {
                        success: "No action required.",
                        warning: "Use of this method of connecting is not recommended as it puts an extra resource load on the " + this.tBrand('app_name') + " systems. See information for your IT provider above.",
                        danger: "Unable to connect to the server using either a direct connection, or a proxied connection via the web service.",
                    },
                    test: this.checkCurrentSocketIo,
                    network_test: true,
                },
                // websocket_future: {
                //     title: "Outgoing websocket connections to new system",
                //     message: "... checking ...",
                //     class: "info",
                //     help: {
                //         success: "No action required.",
                //         warning: "Use of this method of connecting is not recommended as it puts an extra resource load on the " + this.tBrand('app_name') + " systems. See information for your IT provider above.",
                //         danger: "Unable to connect to the server using either HTTPS or direct port 6001.",
                //     },
                //     test: this.checkFutureSocketIo,
                //     network_test: true,
                // },
                webserver_current: {
                    title: "Outgoing web connections to current system",
                    message: "... checking ...",
                    class: "info",
                    help: {
                        success: "No action required.",
                        danger: "Unable to connect to the server",
                    },
                    test: this.checkCurrentWebServer,
                    network_test: true,
                },
                // webserver_future: {
                //     title: "Outgoing web connections to new system",
                //     message: "... checking ...",
                //     class: "info",
                //     help: {
                //         success: "No action required.",
                //         danger: "Unable to connect to the server",
                //     },
                //     test: this.checkFutureWebServer,
                //     network_test: true,
                // },
                screen_resolution: {
                    title: "Screen resolution",
                    message: "... checking ...",
                    class: "info",
                    help: {
                        success: "No action required.",
                        warning: "The minimum officially supported screen size is 1024x768",
                    },
                    test: this.checkScreenResolution,
                    network_test: false,
                },
                user_agent: {
                    title: "User agent",
                    message: "... checking ...",
                    class: "info",
                    help: {
                        success: "This test is for information only.",
                    },
                    test: this.checkOsBrowser,
                    network_test: false,
                },
                user_type: {
                    title: "User type",
                    message: "... checking ...",
                    class: "info",
                    help: {
                        success: "This test is for information only.",
                    },
                    test: this.checkUserType,
                    network_test: false,
                },
                assignable: {
                    title: "In patient assignable group",
                    message: "... checking ...",
                    class: "info",
                    help: {
                        success: "This test is for information only.",
                    },
                    test: this.checkUserAssignable,
                    network_test: false,
                },
                pending_writeback: {
                    title: "Writeback status",
                    message: "... checking ...",
                    class: "info",
                    help: {
                        success: "No action required.",
                        danger: this.autobrand('errors.writeback_max_pending_age_warning', {"hours": this.$root.pendingWritebackWarningHours}),
                    },
                    test: this.checkWritebackMaxPendingAge,
                    network_test: false,
                }
            }
        };
    },

    mounted() {
        Object.keys(this.tests).forEach((value) => {
            this.tests[value].test(value);
        })    
    },
    computed: {
        networkFail() {
            var fail = false;
            Object.keys(this.tests).forEach((value) => {
                console.log("Checking " + value + ": " + this.tests[value].class);
                if(this.tests[value].network_test && (this.tests[value].class == "warning" || this.tests[value].class == "danger")) {
                    fail = true;
                }
            });
            return fail;
        }
    },
    methods: {
        copyText() {
            var report = "";
            Object.keys(this.tests).forEach((value) => {
                report += this.tests[value].title + ": " + this.tests[value].message + "\n";
            })
            if (!navigator.clipboard){
                navigator.clipboard.writeText(report).then(() => {
                    this.addNotification({type: "success", content: "Diagnostics information copied to clipboard"});
                })
                .catch((error) => {
                    alert(error);
                });
            }
        },
        isMemberOfAssignableGroup(user) {
            for(var index in this.$root.lookup.user_groups) {
                if(this.$root.lookup.user_groups[index].members_assignable) {
                    for(var userIndex in this.$root.lookup.user_groups[index].usersusergroup) {
                        if(this.$root.lookup.user_groups[index].usersusergroup[userIndex].user_id == user.id) {
                            return true;
                        }
                    }
                }
            }
            return false;
        },
        checkUserAssignable(test_name) {
            this.tests[test_name].result_data = this.$root.user;
            this.tests[test_name].message = this.isMemberOfAssignableGroup(this.$root.user) ? "Yes" : "No";
            this.tests[test_name].class = "success";
        },
        checkUserType(test_name) {
            this.tests[test_name].result_data = this.$root.user;
            this.tests[test_name].message = Object.keys(this.$root.lookup.user_roles).find(key => {return this.$root.lookup.user_roles[key] == this.$root.user.provider.user_role_id})
            this.tests[test_name].class = "success";
        },
        checkOsBrowser(test_name) {
            this.tests[test_name].result_data = navigator.userAgent;
            this.tests[test_name].message = navigator.userAgent;
            this.tests[test_name].class = "success";
        },
        checkScreenResolution(test_name) {
            this.tests[test_name].result_data = {screen: window.screen, devicePixelRatio: window.devicePixelRatio};
            var devicePixelRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
            var width = window.screen.width * devicePixelRatio;
            var height = window.screen.height * devicePixelRatio;
            if(width < 1024 || height < 768) {
                this.tests[test_name].message = "" + width + "x" + height;
                this.tests[test_name].class = "warning";
            }
            else {
                this.tests[test_name].message = "" + width + "x" + height;
                this.tests[test_name].class = "success";
            }

                
        },
        checkPusher(test_name, prefix) {
            return new Promise((resolve, reject) => {
                //echo_host = window.location.hostname + ":" + (window.environment_settings.MIX_SOCKETIO_PORT + 100);
                this.$root.checkPusherConnect().then(() => {
                    this.tests[test_name].message = "PASSED (DIRECT)";
                    this.tests[test_name].class = "success";
                    this.tests[test_name].result_data = {};
                    resolve();
                }, (reason) => {
                    console.error("Failed to find working websocket connection.");
                    this.tests[test_name].message = "FAILED";
                    this.tests[test_name].class = "danger"; 
                    reject();
                });
            });
        },
        checkCurrentSocketIo(test_name) {
            this.checkPusher(test_name, window.environment_settings.MIX_SOCKETIO_PREFIX);

        },
        checkFutureSocketIo(test_name) {
            // Don't use the actual env setting for the socket prefix
            // as it won't be set pre swingover.
            //window.environment_settings.MIX_SOCKETIO_PREFIX
            this.checkPusher(test_name, "ws-");
            
        },
        checkCurrentWebServer(test_name) {
            axios.get("/diagnostic-test").then(res => {
                this.tests[test_name].message = "PASSED";
                this.tests[test_name].class = "success";
                this.tests[test_name].result_data = res;
            })
            .catch(err => {
                this.tests[test_name].message = "FAILED";
                this.tests[test_name].class = "danger";
                this.tests[test_name].result_data = err;
            });
        },
        checkWritebackMaxPendingAge(test_name) {
            axios.get(this.$root.apiBase + '/filing/pendingAge').then((res) => {
                if(res.data) {
                    if(this.moment().diff(this.moment(res.data), "hours") > this.$root.pendingWritebackWarningHours) {
                        this.tests[test_name].message = "Oldest pending filing in the writeback queue is " + this.moment().diff(this.moment(res.data), "hours") + " hours old";
                        this.tests[test_name].class = "danger";
                        this.tests[test_name].result_data = res;
                    }
                    else {
                        this.tests[test_name].message = "Oldest pending filing in the writeback queue is " + this.moment().diff(this.moment(res.data), "hours") + " hours old";
                        this.tests[test_name].class = "success";
                        this.tests[test_name].result_data = res;
                    }
                    
                }
                else {
                    this.tests[test_name].message = "No pending filings in the writeback queue.";
                    this.tests[test_name].class = "success";
                    this.tests[test_name].result_data = res;
                }
            }).catch((error) => {
                this.tests[test_name].message = "Test failed";
                this.tests[test_name].class = "warning";
                this.tests[test_name].result_data = error;
            });
        },
        checkFutureWebServer(test_name) {
            axios.get("https://mn-" + window.location.hostname + "/diagnostic-test").then(res => {
                this.tests[test_name].message = "PASSED";
                this.tests[test_name].class = "success";
                this.tests[test_name].result_data = res;
            })
            .catch(err => {
                this.tests[test_name].message = "FAILED";
                this.tests[test_name].class = "danger";
                this.tests[test_name].result_data = err;
            });
        },
        isUnsupported(test_name) {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE ");

            this.tests[test_name].result_data = window.navigator.userAgent;

            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
            {
                this.tests[test_name].message = "Internet Explorer";
                this.tests[test_name].class = "warning";
                return true;
            }
            else if(navigator.userAgent.match(/OS 9_[0-9]+(_[0-9]+)? like Mac OS X/i)) {
                this.tests[test_name].message = "Safari 9";
                this.tests[test_name].class = "warning";
                return true;
            }
            else  // If another browser, return 0
            {
                this.tests[test_name].message = "Supported";
                this.tests[test_name].class = "success";
                return false;
            }
        }
    }
}
</script>
